// components/PitchDeck/08_Competition.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function Competition() {
    return (
        <div className="min-h-screen flex items-center bg-gray-50 py-20">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-6xl font-bold text-gray-900 text-center mb-16">
                    Why We Win
                </h2>
                <div className="grid md:grid-cols-4 gap-2">
                    <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
                        <h3 className="text-2xl font-bold text-gray-900 mb-4">Zoho Books</h3>
                        <p className="text-lg text-gray-700">Global, affordable, ecosystem</p>
                        <p className="text-xl font-semibold text-red-600 mt-6">No native FIRS integration</p>
                        <p className="text-xl font-semibold text-red-600 mt-6">Heavy workflow</p>
                        <p className="text-xl font-semibold text-red-600 mt-6"> Fragmented and priced modules</p>
                    </div>
                    <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
                        <h3 className="text-2xl font-bold text-gray-900 mb-4">Sage Accounting</h3>
                        <p className="text-lg text-gray-700">Established, deep features</p>
                        <p className="text-xl font-semibold text-red-600 mt-6">Complex, expensive for SMEs</p>
                        <p className="text-xl font-semibold text-red-600 mt-6">Expensive</p>
                    </div>
                    <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
                        <h3 className="text-2xl font-bold text-gray-900 mb-4">Tyms Accounting</h3>
                        <p className="text-lg text-gray-700">Local, close competitor</p>
                        <p className="text-xl font-semibold text-red-600 mt-6">Lacks accountant-in-your-pocket conversational AI.</p>
                        <p className="text-xl font-semibold text-red-600 mt-6">We're better value &mdash; won competitive bid over them with our first customer.</p>
                    </div>
                    <div className="bg-[#4285F4] p-8 rounded-2xl shadow-2xl text-center text-white transform md:scale-105">
                        <h3 className="text-2xl font-bold mb-4">Arxis Accounting</h3>
                        <p className="text-lg mb-6">Nigeria-first: Direct FIRS, AI chatbot, non-disruptive onboarding</p>
                        <p className="text-2xl font-bold">Local compliance + affordability without workarounds</p>
                    </div>
                </div>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-700/40 rounded-full text-gray-700 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="/pitch/impact-sdg">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}